/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { OptionsInterceptor } from './options-interceptor';
import { SessionInterceptor } from './impersonating-session.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: OptionsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true }
];
